var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.75C14.5 11.1562 14.1875 11.5 13.75 11.5L1.25 11.5C0.84375 11.5 0.5 11.1562 0.5 10.75C0.5 10.3125 0.84375 10 1.25 10L13.75 10C14.1875 10 14.5 10.3125 14.5 10.75ZM12.5 5.75C12.5 6.15625 12.1875 6.5 11.75 6.5L3.25 6.5C2.84375 6.5 2.5 6.15625 2.5 5.75C2.5 5.3125 2.84375 5 3.25 5L11.75 5C12.1875 5 12.5 5.3125 12.5 5.75ZM5.5 0.749999C5.5 0.312499 5.84375 -7.56753e-07 6.25 -7.21238e-07L8.75 -5.02681e-07C9.1875 -4.64434e-07 9.5 0.3125 9.5 0.75C9.5 1.15625 9.1875 1.5 8.75 1.5L6.25 1.5C5.84375 1.5 5.5 1.15625 5.5 0.749999Z",
    fill: "#031621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d62a6337db02ac1e0568e7d6a87df767.svg";
export { ForwardRef as ReactComponent };